<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Nuevo mensaje</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
                >Atrás</base-button
              >
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="handleSubmit">
              <p class="card-text">1. Escribe el mensaje que quieres enviar</p>
              <base-input>
                <textarea
                  class="form-control"
                  v-model="notificacion.descripcion"
                  rows="8"
                  placeholder="Escribe aquí tu mensaje..."
                ></textarea>
              </base-input>

              <p class="card-text">
                2. Selecciona los usuarios a los que quieres enviar el mensaje.
              </p>

              <!-- TABLA DE EMPLEADOS -->
              <el-table
                ref="multipleTable"
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="users"
                @sort-change="sortChange"
                @selection-change="handleSelectionChange"
                empty-text="No hay ningún elemento en esta tabla"
              >
                <!-- LOADING-->
                <div slot="empty" v-if="loading">
                  <img
                    src="/img/loading.gif"
                    style="height: 100px; width: 100px"
                  />
                </div>
                selection<el-table-column type="selection" width="50">
                </el-table-column>

                <el-table-column label="Nombre y apellidos" sortable="custom">
                  <template v-slot="{ row }">
                    <img
                      v-if="row.imagen_perfil && row.imagen_perfil.url"
                      :src="row.imagen_perfil.url"
                      class="avatar rounded-circle mr-2"
                    />
                    <img
                      v-else
                      src="/img/placeholder.png"
                      class="avatar rounded-circle mr-2"
                    />

                    <b>{{ row.nombre + " " + row.apellidos }}</b>
                  </template>
                </el-table-column>

                <el-table-column label="Email" prop="email" sortable="custom" />
                <el-table-column
                  label="Rol"
                  min-width="60px"
                  prop="role.name"
                  sortable="custom"
                >
                  <template v-slot="{ row }">
                    <span>{{ row.role.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Estado"
                  min-width="70px"
                  prop="estado_usuario.id"
                  sortable="custom"
                >
                  <template slot-scope="{ row }">
                    <span
                      class="badge badge-default"
                      :style="[
                        row.estado_usuario.id == 1
                          ? { backgroundColor: 'orange' }
                          : row.estado_usuario.id == 2
                          ? { backgroundColor: 'green' }
                          : { backgroundColor: 'red' },
                      ]"
                      >{{ row.estado_usuario.estado }}</span
                    >
                  </template>
                </el-table-column>
              </el-table>

              <div style="margin-top: 40px">
                <span
                  slot="footer"
                  class="dialog-footer"
                  style="margin-top: 20px"
                >
                  <base-button
                    @click="dialogFormVisible = false"
                    type="secondary"
                    style="margin-right: 8"
                    >Cancelar</base-button
                  >

                  <base-button
                    type="primary"
                    native-type="submit"
                    style="margin: 0; padding-left: 50px; padding-right: 50px"
                  >
                    Enviar
                  </base-button>
                </span>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { Select, Option, Table, TableColumn } from "element-ui";
import { cloneDeep } from "lodash";
import moment from "moment";

export default {
  layout: "DashboardLayout",
  components: {
    BaseInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  mixins: [formMixin],

  data() {
    return {
      available_tipos: [],
      available_empresas: [],
      available_revisores: [],
      available_estados: [],
      multipleSelection: [],
      users: [],

      notificacion: {
        type: "notificaciones",
        descripcion: null,
        estado_notificacion: {
          id: 1,
        },
        tipo_notificacion: {
          id: 5,
        },
        usuario_origen: {
          id: null,
        },
        usuario_destinos: [],
        empresa: {
          id: null,
        },
      },
    };
  },

  created() {
    this.getUsuarios();
  },

  watch: {
    /*  color: {
      handler: "updateTagColor",
      immediate: true,
      deep: true,
    }, */
  },

  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async handleSubmit() {
      this.notificacion.usuario_destinos = this.multipleSelection;
      console.log("NOTIFICACIÓN: ");
      console.log(this.notificacion);

      try {
        await this.$store.dispatch("notificaciones/add", this.notificacion);
        this.$notify({
          type: "success",
          message: "Se ha enviado la notificación correctamente.",
        });
        this.goBack();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal",
        });
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },

    async getTipos() {
      try {
        this.$store.dispatch("tiposNotificacion/list").then(() => {
          this.available_tipos = cloneDeep(
            this.$store.getters["tiposNotificacion/dropdown"]
          );
          this.available_tipos.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getUsuarios() {
      var planta = localStorage.getItem("plantaSelected");

      await this.$store.dispatch("profile/me");

      try {
        let profile = await this.$store.getters["profile/me"];
        console.log(profile);

        this.notificacion.usuario_origen.id = profile.id;

        var empresas = [];
        profile.empresas.forEach((element) => {
          empresas.push(element.id);
        });

        if (planta != 0) {
          empresas = [planta];
        }
        this.notificacion.empresa.id = planta;
        var filters = {
          $and: [
            {
              empresas: {
                id: { $in: empresas },
              },
            },
            { $or: [] },
          ],
        };
        let params = {
          filters: filters,
          pagination: {
            page: 1,
            pageSize: 100,
          },
        };
        await this.$store.dispatch("users/list", params).then(() => {
          var usrs = this.$store.getters["users/list"];

          this.users = usrs;
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getEstados() {
      try {
        this.$store.dispatch("estadosNotificacion/list").then(() => {
          this.available_estados = cloneDeep(
            this.$store.getters["estadosNotificacion/dropdown"]
          );
          this.available_estados.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
